module.exports = __webpack_public_path__ + "static/media/ic-user-thin-gray.faf41c37.svg";